export default {
  name: 'text-view',
  props: ['value', 'isPassWord'],
  render() {
    return <div>{this.isPassWord ? '******' : this.value}</div>;
  },
};
